// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"f55955d3","102":"4e91769c","237":"4073a0ba","264":"5fc21a96","881":"00c37594"}[chunkId] + ".chunk.js";
};